import { graphql, StaticQuery } from "gatsby"
import React from "react"
import InnerWrapper from "./innerWrapper"

import Slide from "react-reveal/Slide"
import styles from "./scss/clients.module.scss"
const Awards = () => (
  <StaticQuery
    query={graphql`
      query {
        allContentfulClient {
          edges {
            node {
              logo {
                title
                description
                fixed(width: 500) {
                  src
                  srcWebp
                }
              }
              url
            }
          }
        }
      }
    `}
    render={data => {
      return (
        <section className={styles.clients}>
          <InnerWrapper width={1440}>
            <h2>Awards</h2>
            <div className={styles.container}>
              <div className={styles.gallery}>
                {data.allContentfulClient.edges.map((edge, index) => {
                  if (edge.node.logo.title === "marketing company") {
                    return (
                      <Slide left key={index}>
                        <a href={edge.node.url}>
                          <img
                            src={edge.node.logo.fixed.src}
                            alt={edge.node.logo.description}
                          />
                        </a>
                      </Slide>
                    )
                  }
                  return null
                })}
              </div>
            </div>
          </InnerWrapper>
        </section>
      )
    }}
  />
)

export default Awards
